export default "__VITE_ASSET__Q$r325_m__"